import React, { PureComponent } from 'react';
import { PrimaryButton } from 'appSrc/components/UI';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import { FormTextField, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import style from './styles/style.module.css';

class AdvertiserForm extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {};
    }
    static advertiserDomainsToText = ( domainData ) => {
        let domainsOnly = domainData.map( eachDomain => eachDomain.domain );
        return domainsOnly.join('\n');
    }
    static advertiserDomainsToArray = ( domainsText ) => {
        let domains = domainsText.split('\n').map( domain => domain.trim() );
        return domains.filter( domain => domain != '' );
    }
    submitHandler = ( values ) => {
        let data = {
            advertiserid: values.advertiserid,
            advertiser_name: values.advertiser_name,
            domains: AdvertiserForm.advertiserDomainsToArray(values.advertiserDomainsText),
        };
        this.props.onSubmit( { advertiser: data } );
    }
    render() {
        const { handleSubmit } = this.props;

        return (
            <div>
                <Form
                onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>
                        <div className={ style.detailsWrapper }>
                            <Field
                            id="affiliateType"
                            name="affiliateType"
                            label="Affiliate Type"
                            component={ FormTextField }
                            props={{
                                disabled: true,
                            }}
                            fullWidth />
                            <Field
                            id="advertiser_name"
                            name="advertiser_name"
                            label="Advertiser Name"
                            component={ FormTextField }
                            fullWidth />
                            <Field
                            id="advertiserDomainsText"
                            name="advertiserDomainsText"
                            component={ FormTextArea }
                            multiLine={ true }
                            label="Advertiser Domains (one per line)"
                            fullWidth />

                            <PrimaryButton
                            label="Submit"
                            fullWidth
                            type="submit"
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}
AdvertiserForm.defaultProps = {
    initialValues: {},
};

AdvertiserForm = reduxForm( {
    form: 'AdvertiserForm',
} )( AdvertiserForm );

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'AdvertiserForm', field, value ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( AdvertiserForm );
